module.exports = __webpack_public_path__ + "141d4a85/img/chevron-down-icon.5542f65c.svg";